import { useTranslation } from 'react-i18next'
import { Select } from '@/components/ui/select'
import { useBanks } from '../../banks'
import { BankLogo } from './BankLogo'

/** Merkezi banka listesinden seçim (logolu). Pasif banka yalnız mevcut seçimse listede kalır. */
export function BankSelect({
  id,
  value,
  onChange,
  allowEmpty = true,
  emptyLabel,
}: {
  id: string
  value: string
  onChange: (id: string) => void
  allowEmpty?: boolean
  /** Boş seçeneğin metni (filtrede "Tüm bankalar"). */
  emptyLabel?: string
}) {
  const { t } = useTranslation()
  const banks = useBanks().data ?? []
  const options = banks.map((b) => ({ value: b.id, label: b.shortName || b.name, icon: <BankLogo url={b.logoUrl} name={b.name} /> }))
  return (
    <Select
      id={id}
      value={value}
      onChange={onChange}
      searchable
      placeholder={t('finance.banks.select')}
      options={allowEmpty ? [{ value: '', label: emptyLabel ?? t('finance.banks.none') }, ...options] : options}
    />
  )
}
